import { mapKeyDefault } from '@onviobr/helpers';
function baseChecker(sessionPermissions, permissions, hasEveryProp) {
    if (typeof permissions === 'string') {
        return mapKeyDefault(sessionPermissions, permissions) === 'Granted';
    }
    let granted = false;
    permissions[hasEveryProp ? 'every' : 'some'](permission => {
        granted = mapKeyDefault(sessionPermissions, permission) === 'Granted';
        return granted;
    });
    return Boolean(granted);
}
/**
 * Checks if any of the given permissions (FRPs) are granted.
 * @public
 * @param sessionPermissions - The session permissions (FRPs) to check.
 * @param permissions - The permissions (FRPs) to check.
 * @returns `true` if any of the given permissions (FRPs) are granted, `false` otherwise.
 */
export function hasSome(sessionPermissions, permissions) {
    return baseChecker(sessionPermissions, permissions);
}
/**
 * Checks if all of the given permissions (FRPs) are granted.
 * @public
 * @param sessionPermissions - The session permissions (FRPs) to check.
 * @param permissions - The permissions (FRPs) to check.
 * @returns `true` if all of the given permissions (FRPs) are granted, `false` otherwise.
 */
export function hasEvery(sessionPermissions, permissions) {
    return baseChecker(sessionPermissions, permissions, true);
}
/**
 * Checks if any of the given permissions (FRPs) are NOT granted.
 * @public
 * @param sessionPermissions - The session permissions (FRPs) to check.
 * @param permissions - The permissions (FRPs) to check.
 * @returns `true` if any of the given permissions (FRPs) are NOT granted, `false` otherwise.
 */
export function notSome(sessionPermissions, permissions) {
    return !baseChecker(sessionPermissions, permissions, false);
}
/**
 * Checks if all of the given permissions (FRPs) are NOT granted.
 * @public
 * @param sessionPermissions - The session permissions (FRPs) to check.
 * @param permissions - The permissions (FRPs) to check.
 * @returns `true` if all of the given permissions (FRPs) are NOT granted, `false` otherwise.
 */
export function notEvery(sessionPermissions, permissions) {
    return !baseChecker(sessionPermissions, permissions, true);
}
